import { createSelector } from "reselect";
import { SharedState } from "../types/SharedState";

// TODO(cochamberlain): Merge this file into session and remove this function.
const getSessionState = (state: SharedState) => state.session;

/** Selects the current user information from state. */
export const getCurrentUser = createSelector(
  [getSessionState],
  session => session.user
);

/** Selects whether or not the current user is anonymous. */
export const getIsAnonymous = createSelector(
  [getCurrentUser],
  user => user === null || user.id === null || user.id <= 0
);

/** Selects the current users role. */
export const getUserRole = createSelector(
  [getCurrentUser],
  user => (user === null ? null : user.role)
);

/** Selects whether or not the current user is anonymous. */
export const getIsAdmin = createSelector(
  [getUserRole],
  role => role !== null && role === "admin"
);

/** Selects the current user id. */
export const getUserId = createSelector(
  [getCurrentUser],
  user => (user === null ? null : user.id)
);

/** Selects the current user username. */
export const getUserUsername = createSelector(
  [getCurrentUser],
  user => (user === null ? null : user.username)
);

/** Selects the current user name. */
export const getUserName = createSelector(
  [getCurrentUser],
  user => (user === null ? null : user.name)
);

/** Selects whether the current user phone is verified. */
export const getUserIsPhoneVerified = createSelector(
  [getCurrentUser],
  user => (user === null ? null : user.isPhoneVerified)
);

/** Selects the current users thumbnail url. */
export const getUserThumbnailUrl = createSelector(
  [getCurrentUser],
  user => (user === null ? null : user.thumbnail)
);
